import { SiTrackPage } from '../../../../components/si-track-page';

import SaveMunicipality from './save_municipality';

export const CreateMunicipalityPage = () => {
  return (
    <SiTrackPage title="Create Municipality">
      <SaveMunicipality />
    </SiTrackPage>
  );
};
